var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner--circle-7",style:(_vm.styles)},[_c('div',{staticClass:"spinner-inner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }